module.exports = __webpack_public_path__ + "img/Nicaragua.e517c0d9.svg";